module.exports = __webpack_public_path__ + "img/join-us-2.9fb6d923.png";